import { render, staticRenderFns } from "./Item-public.vue?vue&type=template&id=479836d8&scoped=true&lang=pug"
import script from "./Item-public.vue?vue&type=script&lang=js"
export * from "./Item-public.vue?vue&type=script&lang=js"
import style0 from "./Item-public.vue?vue&type=style&index=0&id=479836d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479836d8",
  null
  
)

export default component.exports